import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AccordionGroup from '@cx/ui/AccordionGroup';
import Button from '@cx/ui/Button';

export const StockNumberFilterComponent = props => {
  const [selectedValue, setSelectedValue] = useState('');

  const stockNumber = React.createRef();

  const handleChange = event => {
    event.preventDefault();
    setSelectedValue(event.target.value);
  };

  const handleApply = () => {
    const value = selectedValue.toLowerCase();
    setSelectedValue(value);
    props.handleFilterUpdate('stockNumber', value);
  };

  const handleReset = () => {
    stockNumber.current.value = '';
    setSelectedValue('');
    props.handleFilterUpdate('stockNumber', '');
  };

  return (
    <section className="vlp-filter">
      <AccordionGroup.Container htmlId="stockNumberFilter" independent>
        <AccordionGroup.Item header="Stock Number" eventKey="1" htmlId="stockNumberFilterItem">
          <div className="form-group">
            <input type="text" className="form-control" id="stockNumber" aria-describedby="stockNumberHelp" ref={stockNumber} onChange={handleChange} />
            <small id="stockNumberHelp" className="form-text text-muted">
              e.g. 0U3Q20IK9LLD00CY6
            </small>
          </div>
          <Button htmlId="btnReset" onClick={handleReset} disabled={selectedValue === ''}>
            Reset
          </Button>
          &nbsp;
          <Button htmlId="btnApply" buttonStyle="primary" onClick={handleApply} disabled={selectedValue === ''}>
            Apply
          </Button>
        </AccordionGroup.Item>
      </AccordionGroup.Container>
    </section>
  );
};

StockNumberFilterComponent.propTypes = {
  filter: PropTypes.string,
  handleFilterUpdate: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/vehicles/filters/filter/stockNumberFilter.component.js